import { Component, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-viewer',
  imports: [],
  templateUrl: './pdf-viewer.html',
  styleUrl: './pdf-viewer.less'
})
export class PdfViewer {

  @Input() pdfUrl: SafeResourceUrl | null = null;

  get safePdfUrl(): SafeResourceUrl | null {
    return this.pdfUrl;
  }

  get hasPdfUrl(): boolean {
    return this.pdfUrl !== null;
  }
}
